import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import { Button, Header } from 'semantic-ui-react'
import { Formik, Form } from "formik";
import * as Yup from 'yup';
import {MySelectInput} from "../../app/common/form/MySelectInput";
import { SaldosReportesFormValues } from "../../app/models/SaldosReporte";
import '../Pagos/Operaciones_style.css'
import { Message } from 'semantic-ui-react'
import MyTextInput from "../../app/common/form/MyTextInput";
import StickyHeadTable from "./TablaReporteBanrural";
import XLSX from "xlsx";
import ReactExport from 'react-export-excel';
import SubMenuOPReportes from "../Operaciones/MenuOperaciones";
import Container from 'react-bootstrap/Container';
import Pagination from 'react-bootstrap/Pagination';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default observer(function ReporteBanrural() {

    const {ReporteBanruralStore, modalStore, SaldosReporteStore} = useStore();
    const {busquedaInforme, descargaInforme} = ReporteBanruralStore
    const {SaldosByCodigo, reporte} = SaldosReporteStore;
    const mensajeData = false

    const [currentPage, setCurrentPage] = useState(1);
    const [keyword, setKeyword] = useState('');

    useEffect( () => {
        busquedaInforme(keyword, currentPage, 12)
    }, [busquedaInforme, keyword, currentPage])

    const {loading} = SaldosReporteStore; 
  
    const validationSchema = Yup.object({
        busqueda: Yup.string().required('Obligatorio'),
    })

    function handleFormSubmit(valor: any) {
        setKeyword(valor['busqueda']);
        busquedaInforme(keyword, currentPage, 12)
    }

    const handlePageClick = (numberPagina: number, keyword: string) => {
        setCurrentPage(numberPagina);         
        setKeyword(keyword);
    }

    const handleDownload = () => {
        descargaInforme(keyword);
    }

    /** Pagination list */
    const neighbors = 2

    let items = [];
    for (let number = 1; number <= ReporteBanruralStore.totalPages; number++) {
        if (
            number === 1 ||
            number === ReporteBanruralStore.totalPages ||
            (number >= currentPage - neighbors && number <= currentPage + neighbors)
        ) {
            items.push(
                <Pagination.Item key={number} activeLabel={""} onClick={() => {
                    handlePageClick(number, keyword);
                }} active={number === currentPage}>
                    {number}
                </Pagination.Item>,
            );
        } else if (
            (number === currentPage - neighbors - 1) ||
            (number === currentPage + neighbors + 1)
        ) {
            items.push(
                <Pagination.Item key={number} disabled>
                    ...
                </Pagination.Item>
            );
            // Saltar los números entre los puntos suspensivos
            if (number < currentPage) number = currentPage - neighbors - 1;
            else number = ReporteBanruralStore.totalPages - 1;
        }
    }
    
    return (

        <>
            <SubMenuOPReportes />

            <div>
                <div className="header_operaciones">
                    <h2>Reporte Pagos</h2>
                </div>
                
                <div className="buscar_operaciones mt-5">
                    <div className="d-flex justify-content-between">
                        <Formik validationSchema={validationSchema} 
                                enableReinitialize 
                                initialValues={{busqueda:""}} 
                                onSubmit={values => handleFormSubmit(values)}>
                            {({handleSubmit, isValid, isSubmitting, dirty}) => (
                                <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                                    <div className='form_buscar_operaciones'>
                                    <div>
                                        <MyTextInput id="busqueda" name='busqueda' placeholder=' ' />
                                    </div>
                                    <div className="boton_buscar_operaciones">
                                        <Button
                                        loading={loading} 
                                        type='submit' 
                                        content='Buscar' 
                                        style={{backgroundColor: "#15b3e8", color: "white"}}/>
                                    </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                        <button onClick={handleDownload} style={{ backgroundColor: "#15b3e8", color: "#ffffff", paddingRight: "20px", paddingLeft: "20px", border: "0" }}>Exportar a CSV</button>

                        {/* <ExcelFile element={<Button
                                        type='submit' 
                                        content='Exportar a CSV' 
                                        style={{backgroundColor: "#15b3e8", color: "white"}}/>}>
                            <ExcelSheet data={ReporteBanruralStore.ReporteBanruralByCodigo} name="data">
                                <ExcelColumn label="No." value="id"/>
                                <ExcelColumn label="No. de Documento Contable" value="numeroDocumentoContable"/>
                                <ExcelColumn label="No. de Boleta" value="numeroBoleta"/>
                                <ExcelColumn label="Nombre" value="nombre"/>
                                <ExcelColumn label="Nombre del Curso" value="nombreCurso"/>
                                <ExcelColumn label="Código de Curso" value="codigoDeCurso"/>
                                <ExcelColumn label="Monto" value="monto"/>
                                <ExcelColumn label="Fecha de Pago" value="fechaPago"/>
                            </ExcelSheet>
                        </ExcelFile>   */}  
                    </div>                                        
         
                    <div className="mt-5">
                        <StickyHeadTable />
                    </div>                   
                    
                </div>

                <div className="mt-5">
                    <Container className='pagination-convenios-area'>
                        <Pagination>{items}</Pagination>
                    </Container>
                </div>
            </div>
        </>

    )
})